module.exports = __webpack_public_path__ + "static/media/pagination-previous-page.b369f1a7.svg";